export default __webpack_public_path__ + "static/media/prize3.60b83cc9.svg";